/**
 * List of error codes - the value string represents the key in the translation.json file
 */
export enum ERROR_CODES {
  OK = 'OK',
  passInvalid = 'passwordLength',
  passEqualsName = 'passwordEqualsCommonName',
  passSimilarName = 'passwordSimilarCommonName',
  passwordEqualsEmail = 'passwordEqualsEmail',
  passwordEqualsPassword = 'passwordEqualsPassword',
  passWeak = 'passwordWeak',
  passWrong = 'passwordWrong',
  passNotSame = 'passwordNotSame',
  nameInuse = 'commonNameInUse',
  nameInvalid = 'commonNameInvalidFormat',
  nameToShort = 'commonNameLength',
  nameBlacklisted = 'commonNameBlacklisted',
  nameErrorUnknown = 'error_message_defaultError',
  mailInuse = 'emailInUse',
  mailInvalid = 'emailInvalid',
  mailBlacklisted = 'emailDomainBlacklisted',
  // generic error message
  required = 'required',
  unknownError = 'unknownError',
}

export const PASSWORD_ERRORS = [
  ERROR_CODES.passEqualsName,
  ERROR_CODES.passInvalid,
  ERROR_CODES.passNotSame,
  ERROR_CODES.passWeak,
  ERROR_CODES.passWrong,
  ERROR_CODES.passwordEqualsEmail,
  ERROR_CODES.passwordEqualsPassword,
]

export const NAME_ERRORS = [
  ERROR_CODES.nameInuse,
  ERROR_CODES.nameInvalid,
  ERROR_CODES.nameToShort,
  ERROR_CODES.nameBlacklisted,
  ERROR_CODES.nameErrorUnknown,
]

export const MAIL_ERRORS = [ERROR_CODES.mailInuse, ERROR_CODES.mailInvalid, ERROR_CODES.mailBlacklisted]
